import { Component, OnInit } from '@angular/core';
import { AbstractControl, FormControl, FormGroup, ValidationErrors, ValidatorFn, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { Globals } from 'src/app/globals';
import { TranslateService } from '@ngx-translate/core';
import { UserService } from 'src/app/service/user.service';
import { RoleService } from 'src/app/service/role.service';
import { OrgService } from 'src/app/service/org.service';
import { CoursesService } from 'src/app/service/courses.service';
import { AcademicsService } from 'src/app/service/academics.service';
@Component({
  selector: 'app-teacher-create',
  templateUrl: './teacher-create.component.html',
  styleUrls: ['./teacher-create.component.scss']
})
export class TeacherCreateComponent implements OnInit {

  
 showLoader: boolean = false;
  creating: boolean = false;
  ShowFilter = true;

  avaRoles: any;
  allIsps: any;

  createTeacher = new FormGroup({
    code: new FormControl('', [
      Validators.required,
    ]),
    titleAr: new FormControl('', [
      Validators.required, 
      ]),
    titleEn: new FormControl('', [
      Validators.required, 
      ]),
    nameAr: new FormControl('', [
      Validators.required, 
      ]),
    nameEn: new FormControl('', [
      Validators.required,
      ]),
    gender: new FormControl('', [
      Validators.required,
    ]),
    teacherType: new FormControl('', [
      Validators.required,
    ]),
    
    
  }, );

  constructor(
    // private userService: UserService,
    //  private ispService: IspService,
    private toastrService: ToastrService
    // , private roleService: RoleService
    , public globals: Globals, private toastr: ToastrService, private activatedRoute: ActivatedRoute, private router: Router
    , public translate: TranslateService
    , private coursesService: CoursesService
    , private roleService: RoleService
    , private orgService: OrgService
    , private academicsService: AcademicsService
  ) {

  }

  // changeRole(e: any) {
  //   this.createTeacher.value.roleType = e.target.value, {
  //     onlySelf: true
  //   }
  // }
  ngOnInit(): void {
   
  }

  createTeacherChange() {
    // let classHours = this.createTeacher.controls.classHours.value;
    // let clinicalHours = this.createTeacher.controls.clinicalHours.value;
    // this.createTeacher.controls.totalHours.setValue(Number(classHours) + Number(clinicalHours));
  }

  createTeacherSubmit() {
    if (this.createTeacher.valid) {

      let teacherCode = this.createTeacher.controls.code.value;
      let titleNameAr = this.createTeacher.controls.titleAr.value;
      let titleNameEn = this.createTeacher.controls.titleEn.value;
      let teacherNameAr = this.createTeacher.controls.nameAr.value;
      let teacherNameEn = this.createTeacher.controls.nameEn.value;
      let gender = this.createTeacher.controls.gender.value;
      let teacherType = this.createTeacher.controls.teacherType.value;
      this.addTeacher(teacherCode, teacherNameAr, teacherNameEn, titleNameAr, titleNameEn,
        gender, teacherType)
    }
    else {
      this.createTeacher.markAllAsTouched();
      this.createTeacher.markAsDirty();
    }
  }

  addTeacher(teacherCode: string, teacherNameAr: string, teacherNameEn: string, titleNameAr: string, titleNameEn: string, gender: string, teacherType: string) {
    this.creating = true;
    let username = this.globals.currentUserInfo.username;
    let orgId = this.globals.currentUserInfo.orgid;

    this.academicsService.addTeacher(username, orgId, teacherCode, teacherNameAr, teacherNameEn, titleNameAr, titleNameEn, gender, teacherType)
      .subscribe(
        data => {
          if (data.sts == "SUCCESS") {
            this.toastrService.success(this.translate.instant('ADDED_SUCCESSFULLY'));
            this.router.navigate(['/academics/teacher']);
          } else {
            this.creating = false;
            this.toastrService.error(this.translate.instant('FAIL_TO_CREATE'));
          }
        },
        error => {
          this.creating = false;
          this.toastrService.error(this.translate.instant('FAIL_TO_CREATE'));
        }
      );
  }
 



  onItemSelect(item: any) {
    // console.log('onItemSelect', item);
  }
  changegender(){

  }

}
